import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/libs/axios';
import type { Role } from '../types/roles.type';
import type { ApiResponse } from '@/types/api.type';

export type GetRoleParams = {
  roleId?: string;
};
export type GetRoleResponse = ApiResponse<Role>;

export const getRole = async (
  params?: GetRoleParams
): Promise<GetRoleResponse> => {
  const url = `/role/${params?.roleId}`;

  return apiClient.get(url);
};

export const GET_ROLE_QUERY_KEY = 'get-role';

export const getRoleQueryOptions = (params?: GetRoleParams) =>
  queryOptions({
    queryKey: [GET_ROLE_QUERY_KEY, params],
    queryFn: () => getRole(params),
  });
